module.exports = __webpack_public_path__ + "static/media/1coachHeader.6bedb211.svg";